import { render, staticRenderFns } from "./VariableGroup.vue?vue&type=template&id=5ef95cb7&"
import script from "./VariableGroup.vue?vue&type=script&lang=ts&"
export * from "./VariableGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports